import { tw } from '@careinfo/tailwind';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { AddSmsCampaign } from '../../../utils/validationSchemas';
import AddSmsModal from '../../QuickSms/AddQuickSmsModal/AddQuickSmsModal';
import Button from '../../Reusable/Button';
import Card from '../../Reusable/Card';
import MobilePreview from '../../Reusable/MobilePreview/MobilePreview';
import SmsCampaignForm from '../SmsCampaignForm/SmsCampaignForm';

const SmsCampaignUpdate = (props: any) => {
  const { data, handleEdit, isLoading } = props;
  const {
    register,
    handleSubmit,
    watch,
    setError,
    setValue,
    getValues,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(AddSmsCampaign),
    defaultValues: {
      ...data,
      recipient: data?.recipient_list?.split(',') || [],
    },
  });

  const message = watch('content');

  const [isAddEmailModalOpen, setIsAddEmailModalOpen] = useState(false);
  const handlePlusButton = (e) => {
    e.preventDefault();
    setIsAddEmailModalOpen(true);
  };

  return (
    <div>
      <div className={tw`pb-2`}>
        <h1 className={tw`text-lg font-semibold`}> SMS Campaign Create</h1>
      </div>
      <div className={tw`pt-4`}>
        <div className={tw`min-h-[550px]`}>
          <Card>
            <div className={tw`flex flex-col lg:flex-row gap-4`}>
              <div className={tw`w-full lg:w-3/4`}>
                <form
                  className={tw`flex flex-col gap-4`}
                  onSubmit={handleSubmit((data) => {
                    handleEdit(data, setError, false);
                  })}
                >
                  <SmsCampaignForm
                    register={register}
                    errors={errors}
                    control={control}
                    setValue={setValue}
                    watch={watch}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    handlePlusButton={handlePlusButton}
                  />
                  <div className={tw`flex justify-end`}>
                    <div className={tw`mr-7`}>
                      <div className={tw`w-40`}>
                        <Button
                          label='Save Draft'
                          type='button'
                          isLoading={isLoading}
                          disabled={!data?.is_draft || false}
                          onClick={handleSubmit((data) => {
                            handleEdit(data, setError, true);
                          })}
                        />
                      </div>
                    </div>

                    <div className={tw`w-40`}>
                      <Button
                        label={'Update'}
                        type='submit'
                        disabled={!data?.is_draft || false}
                        isLoading={isLoading}
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div
                className={tw`hidden lg:flex items-center justify-center w-full lg:w-1/4`}
              >
                <div className='relative'>
                  <MobilePreview
                    imageUrl='https://dev-dib-pos-frontend-service-v3.s3.ap-south-1.amazonaws.com/digital-marketing-frontend-service/dist/30f7156109f80ad3a4d3.png'
                    description='Placeholders will be replaced for all contacts in a list. This is an example of the first contact.'
                    message={message}
                  />
                </div>
              </div>
            </div>
          </Card>
          <AddSmsModal
            isOpen={isAddEmailModalOpen}
            setIsOpen={setIsAddEmailModalOpen}
          />
        </div>
      </div>
    </div>
  );
};

export default SmsCampaignUpdate;
